import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getCourses = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/courses`, { params });
};

export const getCourse = async (params) => {
  return await axios.get(`${baseURL}/course`, { params });
};

export const addCourse = async (params) => {
  return await axios.post(`${baseURL}/course`, params);
};

export const updateCourse = async (id, params) => {
  return await axios.put(`${baseURL}/course/${id}`, params);
};
export const fetchCourseApplication = async (params) => {
  try {
    const res = await axios.get(`${baseURL}/course/applications`, {
      params
    });
    const data = res.data;
    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};
export const submitApplicationStatus = async (params) => {
  try {
    const res = await axios.put(
      `${baseURL}/course/${params?._id}/update-application-status`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};
export const sendPaymentLink = async (params) => {
  try {
    const res = await axios.post(
      `${baseURL}/course/${params?._id}/send-payment-link`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};
export const updateApplication = async (params) => {
  try {
    const res = await axios.put(
      `${baseURL}/course/application/${params._id}`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};
